import _ from 'lodash';
import { adminClient as apolloClient } from '@/store/apollo';

import TimeEntriesPaginatedGql from '@/extensions/tickets/store/graphql/queries/TimeEntriesPaginated.gql';

export default {
    /**
     * One page of booked times. The desk travels with the request the way it
     * does for the ticket list — the surface says which desk it is, and the
     * server scopes the entries through the ticket they sit on.
     */
    fetchPaginated: (state, desk) =>
        new Promise((resolve, reject) => {
            // The stored filter values already carry their own `key`, so the
            // list is the values themselves — same as the project list.
            const filters = [];
            _.each(state.filters, (entry) => filters.push(entry));

            apolloClient
                .query({
                    query: TimeEntriesPaginatedGql,
                    fetchPolicy: 'network-only',
                    variables: {
                        desk: desk || undefined,
                        currentPage: _.get(state, 'pageInfo.currentPage', 1),
                        perPage: _.get(state, 'pageInfo.perPage', 25),
                        order: _.get(state, 'variables.order', 'started_at'),
                        direction: _.get(state, 'variables.direction', 'desc'),
                        link: _.get(state, 'link.route', ''),
                        filters,
                    },
                })
                .then(({ data }) => resolve(data.EX_TCKT_TicketTimeEntriesPaginated))
                .catch((err) => reject(err));
        }),
};
